import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import Player from '@vimeo/player'
import Image from '~components/Image'
import { SoundOn, SoundOff, FullScreen } from '~components/Svg'

const Vimeo = ({ className, videoId, relativeHeight, placeholder, aspectRatio }) => {
	const [play, setPlay] = useState(false)
	const [muted, setMuted] = useState(true)
	const [player, setPlayer] = useState()

	const [initialPlay, setInitialPlay] = useState()

	// Vimeo variables

	const videoContainer = useCallback((node) => {
		let options = {
			id: videoId,
			loop: true,
			byline: false,
			title: false,
			portrait: false,
			controls: false,
			muted: false,
			autoplay: false,
		}
		if (node) setPlayer(new Player(node, options))
	}, [])

	const togglePlay = () => {
		if (!play) {
			player?.play()
			setPlay(true)
		} else {
			player?.pause()
			setPlay(false)
		}
	}

	const setFullScreen = () => {
		player?.requestFullscreen()
	}

	const toggleMuted = () => {
		if (!muted) {
			player
				.setMuted(true)
				.then(function (muted) {
					setMuted(true)
				})
				.catch(function (error) {
					// an error occurred
				})
		} else if (muted) {
			player
				.setMuted(false)
				.then(function (muted) {
					setMuted(false)
				})
				.catch(function (error) {
					// an error occurred
				})
		}
	}

	useEffect(() => {
		player?.on('playing', function () {
			setInitialPlay(true)
		})
	}, [play])

	return (
		<Wrap className={className}>
			<Inner>
				<Placeholder cover image={placeholder} playing={initialPlay} />

				<>
					<PlayButton className="h2" onClick={togglePlay} play={play}>
						Play
					</PlayButton>

					<FullScreenButton onClick={() => setFullScreen()}>
						<FullScreen />
					</FullScreenButton>

					<SoundButton onClick={() => toggleMuted()} play={play}>
						{muted ? <SoundOn /> : <SoundOff />}
					</SoundButton>
				</>

				<Overlay />
				{videoId && (
					<Video
						ref={videoContainer}
						css={css`
							padding-bottom: ${(1 / aspectRatio) * 100 + '%'};
						`}
					/>
				)}
			</Inner>
		</Wrap>
	)
}

const Wrap = styled.div``
const Inner = styled.div`
	position: relative;
	line-height: 0;
`
const Video = styled.div`
	position: relative;
	height: 0;
	overflow: hidden;
	max-width: 100%;
	width: 100%;
	transition: opacity 1s;
	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
`
const Placeholder = styled(Image)`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 2;
	opacity: ${(props) => (props.playing ? '0' : '1')};
	transition: opacity 0.3s;
`
const PlayButton = styled.button`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	text-align: center;
	color: var(--white);
	z-index: 10;
	opacity: ${(props) => (props.play ? '0' : '1')};
	transition: opacity 0.2s;
`

const SoundButton = styled.button`
	color: white;
	position: absolute;
	z-index: 10;
	bottom: 12px;
	right: 42px;
	line-height: 0;
	width: 20px;
	height: 20px;
	pointer-events: ${(props) => (props.play ? 'all' : 'none')};
	opacity: ${(props) => (props.play ? '1' : '0')};
	transition: opacity 0.2s;
`

const FullScreenButton = styled.button`
	color: white;
	position: absolute;
	z-index: 10;
	bottom: 15px;
	right: 15px;
	line-height: 0;
	width: 15px;
	height: 15px;

	transition: opacity 0.2s;
`

const Overlay = styled.div``

Vimeo.propTypes = {
	className: PropTypes.string,
	video: PropTypes.string,
	relativeHeight: PropTypes.bool,
	placeholder: PropTypes.object,
}

export default Vimeo
